import dom from '../../../helpers/dom';
import styles from '../../../helpers/styles';

const socialShare = () => {
  const rckTooltipLabelClass = 'rck-tooltip__label';
  const copyLinkButtonClass = 'js-social-share-copy-link-button';
  const copyLinkTooltipClass = 'js-social-share-copy-link-tooltip';

  const getCopyLinkTooltip = (button) => dom.findSiblingByClassName(button, copyLinkTooltipClass);

  const copyLinkToClipboard = (button) => {
    const link = button.getAttribute('data-clipboard-link');
    // Clipboard not available without HTTPS
    if (window.isSecureContext) {
      navigator.clipboard.writeText(link);
    }
  };

  const hideCopyLinkTooltip = (button) => {
    const tooltip = getCopyLinkTooltip(button);
    const tooltipLabel = dom.getFirstByClassName(rckTooltipLabelClass, tooltip);
    styles.hideElement(tooltip, true);
    tooltipLabel.innerText = '';
  };

  const displayCopyLinkTooltip = (button) => {
    const tooltip = getCopyLinkTooltip(button);
    if (styles.isElementHidden(tooltip)) {
      const tooltipLabel = dom.getFirstByClassName(rckTooltipLabelClass, tooltip);
      const tooltipText = button.getAttribute('data-clipboard-message');
      tooltipLabel.innerText = tooltipText;
      styles.showElement(tooltip, true);
    }
  };

  const init = () => {
    dom.getByClassName(copyLinkButtonClass).forEach((copyLinkButton) => {
      copyLinkButton.addEventListener('click', () => {
        copyLinkToClipboard(copyLinkButton);
        displayCopyLinkTooltip(copyLinkButton);
      });
      copyLinkButton.addEventListener('blur', () => {
        hideCopyLinkTooltip(copyLinkButton);
      });
    });
  };

  return {
    init,
  };
};

export default socialShare();
